// extracted by mini-css-extract-plugin
module.exports = {"Container":"ImgScreen_Container__3_MOG","CardImage":"ImgScreen_CardImage__34WZM","CardImageActive":"ImgScreen_CardImageActive__2DT71"};